import { resizeFile } from "./imageResizeFile";
let existingImages = [];
export const imageFileHandle = async (file,images) => {
    console.log("images and file in ImageHandle",file,images);
    existingImages = images;
    const compressedImage = await resizeFile(file);
    if (existingImages?.length < 4){
        existingImages.push(compressedImage)
    }
    const newImages =  existingImages;
    let imageArr = [];
    let apiImagesArr = [];
    newImages.forEach((imageO) => {
        const base64String = imageO.base64;
        const extractedPart = base64String.replace(/^data:image\/\w+;base64,/, "");
        const base64StringExtracted = extractedPart;
        const stringLength = base64String.length;
        const sizeInBytes = 4 * Math.ceil((stringLength / 3))*0.5624896334383812;
        const sizeInKb=sizeInBytes/1000;
        imageArr.push({base64: base64String, name : imageO.name, size : sizeInKb})
        apiImagesArr.push({fileName : imageO.name,fileContent: base64StringExtracted})
    });

    return {"imageArr":imageArr,"apiImagesArr":apiImagesArr};
}